import { UploadFail } from './UploadFail';

export class UnsupportedFolderTransferFail extends UploadFail {
    static isNotReadableError(error) {
        let isNotReadableError = false;

        if (window.DOMException && error instanceof DOMException) {
            // Chrome
            // @ts-ignore
            isNotReadableError = error.code === DOMException.NOT_READABLE_ERR;
        } else {
            // @ts-ignore
            // eslint-disable-next-line no-lonely-if
            if (window.FileError && error instanceof FileError) {
                // Safari
                // @ts-ignore
                isNotReadableError = error.code === FileError.NOT_READABLE_ERR;
            }
        }

        return isNotReadableError;
    }

    radarName = 'fail_{SOURCE}_unsupported-folder-transfer';
    message = 'Браузер не поддерживает загрузку папок.';
}
